var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"new-feature-bagde"},on:{"click":_vm.goToNewFeatures}},[_c('Icon',{attrs:{"tooltip":"Conheça área de novas aplicações"}},[_c('NewFeatureIcon',{staticClass:"icon"})],1),(_vm.showNewFeature)?_c('div',{staticClass:"unread-indicator"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }